export { default } from './BannerCanaisAtendimento';
